import useGetDeviceVideoFleetSettings from '../videos/useGetDeviceVideoFleetSettings';
import useGetDeviceVideoSettings from '../videos/useGetDeviceVideoSettings';

function useGetDeviceLiveVideoIsEnabled(deviceId: string | undefined, fleetId: string): boolean {
  const { data: fleetConfig, isLoading: isFleetLoading, status: fleetStatus } = useGetDeviceVideoFleetSettings(fleetId);
  const { data: deviceSettings, isLoading, status } = useGetDeviceVideoSettings(deviceId, fleetId);

  const fleetConfigIsExisting = fleetConfig && fleetStatus === 'success';
  const fleetConfigIsActive = fleetConfig?.isActive;

  if (fleetConfigIsExisting && fleetConfigIsActive) {
    return fleetConfig.videoStreamEnable;
  }

  return status === 'success' && deviceSettings.videoStreamEnable;
}

export default useGetDeviceLiveVideoIsEnabled;
